export const getConsumerImageUrl = (hexConsumerIdForUser: string) =>
    // Consumer's own profile picture
    `https://cid-${hexConsumerIdForUser}.users.storage.live.com/users/0x${hexConsumerIdForUser}/myprofile/expressionprofile/profilephoto:UserTileStatic,UserTileSmall/MeControlMediumUserTile?ck=1&ex=24&fofoff=1`;
